import React from 'react';
import {injectIntl} from "react-intl";
import LabeledText from "../../../common/text/LabeledText";
import withAuthorization from "../../../../services/Authorization";
import PictureGallery from "../../../interventiondetail/picture/PictureGallery";
import BoldText from "../../../common/text/BoldText";
import Constants from "../../../../services/Constants";
import moment from 'moment';
import {Divider} from "antd";
import Rental from "../../../../services/Rental";

class RentalCar extends React.Component {

  render() {
    const {intl: {formatMessage}, vehicle} = this.props;
    const isVinVehicle = Rental.isVinVehicle(vehicle);
    const registrationDate = vehicle.registrationDate ? moment(vehicle.registrationDate).format(Constants.DATE_FORMAT_DISPLAY) : null;

    return (
      <div className="box__body--no-padding">
        <h3 className="box__subtitle">{formatMessage({id: 'car-information.main.title'})}</h3>

        <div className="row">
          {vehicle.picture &&
            <div className="col-md-6 col-xxl-6">
              <PictureGallery pictures={[vehicle.picture]}/>
            </div>
          }
          <div className="col-md-6 col-xxl-6">
            {isVinVehicle &&
              <LabeledText label={'vehicle.vin'} text={<BoldText text={vehicle.vin} boldEndCharacters={7}/>}/>
            }
            {!isVinVehicle &&
              <LabeledText label={'vehicle.serialNumber'} text={vehicle.vin}/>
            }
          </div>
          <div className="col-md-6 col-xxl-6">
            <LabeledText label={'vehicle.category'} text={formatMessage({id: `mobility.${vehicle.category}`})}/>
          </div>
          <div className="col-md-6 col-xxl-6">
            <LabeledText label={'vehicle.plate'} text={vehicle.licensePlate}/>
          </div>
          <div className="col-md-6 col-xxl-6">
            <LabeledText label={'vehicle.make'} text={vehicle.brand}/>
          </div>
          <div className="col-md-6 col-xxl-6">
            <LabeledText label={'vehicle.model'} text={vehicle.model}/>
          </div>
          <div className="col-md-6 col-xxl-6">
            <LabeledText label={'vehicle.modelCode'} text={vehicle.modelCode}/>
          </div>
          <div className="col-md-6 col-xxl-6">
            <LabeledText label={'vehicle.status'} text={vehicle.status}/>
          </div>
        </div>

        <Divider/>
        <h3 className="box__subtitle">{formatMessage({id: 'car-information.detailed.title'})}</h3>

        <div className="row">
          {isVinVehicle &&
            <div className="col-md-6 col-xxl-6">
              <LabeledText label={'vehicle.gearbox'} text={vehicle.gearbox ? formatMessage({id: `vehicle.gearbox.${vehicle.gearbox}`}) : undefined}/>
            </div>
          }
          <div className="col-md-6 col-xxl-6">
            <LabeledText label={'vehicle.registration-date'} text={registrationDate}/>
          </div>
          <div className="col-md-6 col-xxl-6">
            <LabeledText label={'vehicle.current-mileage'} text={`${vehicle.lastReport.mileage}Km`}/>
          </div>
          <div className="col-md-6 col-xxl-6">
            <LabeledText label={'vehicle.color'} text={vehicle.color}/>
          </div>
          <div className="col-md-6 col-xxl-6">
            <LabeledText label={'vehicle.remark'} text={vehicle.remark}/>
          </div>
          {isVinVehicle &&
            <div className="col-md-6 col-xxl-6">
              <LabeledText label={'vehicle.current-fuel'} text={vehicle.lastReport.fuel ? `${vehicle.lastReport.fuel}%` : undefined}/>
            </div>
          }
          {isVinVehicle &&
            <div className="col-md-6 col-xxl-6">
              <LabeledText label={'vehicle.co2'} text={vehicle.co2}/>
            </div>
          }
          {isVinVehicle &&
            <div className="col-md-6 col-xxl-6">
              <LabeledText label={'vehicle.fuel-type'} text={vehicle.fuelType ? formatMessage({id: `vehicle.fuel-type.${vehicle.fuelType}`}) : undefined}/>
            </div>
          }
          {isVinVehicle &&
            <div className="col-md-6 col-xxl-6">
              <LabeledText label={'vehicle.additional-km-rate'} text={vehicle.additionalKmRate ? `${vehicle.additionalKmRate}€` : undefined}/>
            </div>
          }
          {isVinVehicle &&
            <div className="col-md-6 col-xxl-6">
              <LabeledText label={'vehicle.deductible'} text={vehicle.deductible ? `${vehicle.deductible}€` : undefined}/>
            </div>
          }
        </div>

        <Divider/>
        <h3 className="box__subtitle">{formatMessage({id: 'car-information.damage.title'})}</h3>

        <div className="row">
          {vehicle.lastReport.attachments &&
            <div className="photos-gallery col-md-12 col-xxl-12">
              <PictureGallery pictures={vehicle.lastReport.attachments}/>
            </div>
          }
          {vehicle.lastReport.advisorComment &&
            <div className="col-md-12 col-xxl-12">
              <LabeledText label={'vehicle.damage-description.advisor'} text={vehicle.lastReport.advisorComment}/>
            </div>
          }
        </div>
      </div>
    )
  }
}

export default withAuthorization(injectIntl(RentalCar), ['DUI_ADMIN', 'DUI_SERVICE_ADVISOR']);
